const BREAD_CRUMB_INITIAL_STATTE = {
	breadCrumbRoute: [],
};

export default BREAD_CRUMB_INITIAL_STATTE;
